// import { PageHeader } from "@ant-design/pro-layout";
import { useParams } from "react-router-dom";
import { SummaryContainer } from "../summary.container";
import { getItem } from "../../../../../../shared/local-storage";


export const ArchiveSummary: React.FC = () => {

  const params = useParams();
  const applicantUserId = getItem('applicantUserId');

  return (
    <SummaryContainer caseId={params.caseId ?? ""} applicantId={applicantUserId ?? ""}/>
  );
};
